import { makeStyles } from '@mui/styles';
import { STYLE } from 'constants/style';

export const useStyles = makeStyles((theme: any) => ({
  instructionContainer: {
    marginTop: '32px',
    [theme.breakpoints.down('sm')]: {
      marginTop: '24px',
    },
  },
  instructionTitle: {
    color: STYLE.COLOR.BLACK,
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '24px',
    marginTop: '6px',
  },
  imagePairContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '16px',
    [theme.breakpoints.down('sm')]: {
      gap: '8px',
    },
  },
  imageWrapper: {
    position: 'relative',
    flex: 1,
    paddingBottom: '24px',
  },
  instructionImage: {
    width: '100%',
    height: 'auto',
    display: 'block',
  },
  badge: {
    position: 'absolute',
    bottom: 0,
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  goodBadgeIcon: {
    width: '16px !important',
    height: '16px !important',
  },
  instructionText: {
    color: STYLE.COLOR.TEXT2,
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
    marginTop: '4px',
    marginBottom: 0,
  },
  warningContainer: {
    marginTop: '52px',
    [theme.breakpoints.down('sm')]: {
      marginTop: '32px',
    },
  },
  captureButton: {
    minWidth: '182px !important',
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: '40px',
  },
}));
